/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const MapIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="MapIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <g>
              <path
                d="M8 6C7.44772 6 7 6.44772 7 7C7 7.55228 7.44772 8 8 8C8.55228 8 9 7.55228 9 7C9 6.44772 8.55228 6 8 6Z"
                fill="currentColor"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.62085 14.076C7.71584 14.1864 7.85431 14.25 8 14.25C8.14569 14.25 8.28414 14.1865 8.37913 14.076L8.48191 13.9567C8.54804 13.88 8.64348 13.7696 8.76056 13.6344C8.99478 13.3641 9.31544 12.9953 9.66137 12.6012C10.3584 11.8072 11.1423 10.9288 11.5355 10.5355C12.4398 9.63125 13 8.38057 13 7C13 4.23858 10.7614 2 8 2C5.23858 2 3 4.23858 3 7C3 8.38057 3.56019 9.63125 4.46446 10.5355C4.85773 10.9288 5.6416 11.8072 6.33863 12.6012C6.68456 12.9953 7.00522 13.3641 7.23944 13.6344C7.35652 13.7696 7.45196 13.88 7.51809 13.9567L7.62085 14.076ZM4 7C4 4.79086 5.79086 3 8 3C10.2091 3 12 4.79086 12 7C12 8.1047 11.5528 9.10402 10.8284 9.82842C10.4074 10.2495 9.60024 11.1551 8.90986 11.9415C8.56209 12.3377 8.23994 12.7082 8.00477 12.9796L8 12.9851L7.99523 12.9796C7.76006 12.7082 7.43791 12.3377 7.09014 11.9415C6.39976 11.1551 5.59263 10.2495 5.17157 9.82842C4.44717 9.10402 4 8.1047 4 7Z"
                fill="currentColor"
              />
            </g>
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

MapIcon.tags = [
  'location',
  'point',
  'drop pin',
  'map',
  'navigate',
  'pin',
  'marker',
];

MapIcon.category = 'General Icons';

MapIcon.iconSize = 16;
